<template>
    <div class="m-listRoom">
        <div class="room-wrap">
            <div class="room-left">
                <div class="room-info">
                    <div class="room-title">
                        <p class="title">{{room.title}}</p>
                    </div>
                    <div class="info">
                        <p class="host" v-show="room.creatorName">{{$t('live.creator')}}：{{room.creatorName}}</p>
                        <p class="time" >{{$t('c.startTime')}}：{{room.startTime}}</p>
                        <p class="time" >{{$t('c.endTime')}}{{room.endTime}}</p>
                        <p class="num">
                            <i class="nucfont inuc-members"></i>
                            {{$t('live.onlineNum')}}：
                            <span>{{onlineNum}}</span></p>
                    </div>
                </div>

                <div class="room-video-wrap" v-if="room">
                    <!--  :class="['offline','online','leave', 'loading'][status]" -->
                    <div class="room-video" id="room-video" :class="{'fake-screen': status!==null && status!==1}">
                        <div class="inner-box" v-if="status!==null && status!==1">
                            <div class="note">
                                <p v-if="status===0">{{$t('live.notStart')}}~</p>
                                <p v-if="status===2">{{$t('live.left')}}~</p>
                                <p v-if="status===3">{{$t('exam.loading')}}</p>
                            </div>
                            <i v-show="status!==3" @click="freshVideo" class="el-icon-refresh" :title="$t('live.refresh')"></i>
                        </div>
                    </div>
                </div>
            </div>

            <div class="room-right">
                <div class="room-aside">
                    <div class="room-desc">
                        {{$t('live.notice')}}：{{room.notice || $t('live.noNotice')}}
                    </div>

                    <div class="room-message">
                        <el-tabs v-model="activeTab" type="card">
                            <el-tab-pane :label="$t('live.chat')" name="chat">
                                <ul class="comment-list">
                                    <li class="comment-item" v-for="item in commentList" :key="item.id">
                                        <span class="user" :class="{'self': item.userId===userInfo.userID}">
                                            {{item.userName}}<i>{{item.time}}：</i>
                                        </span>
                                        <span class="content">{{item.content}}</span>
                                    </li>
                                </ul>
                            </el-tab-pane>
                            <el-tab-pane :label="`${$t('live.audience')} (${onlineNum})`" name="member">
                                <ul class="member-list">
                                    <li class="member-item" v-for="(item, index) in memberList" :key="item.id">
                                        <el-avatar :size="30">{{item.name.slice(-2)}}</el-avatar>
                                        <p class="name">{{item.name}}</p>
                                    </li>
                                </ul>
                            </el-tab-pane>
                        </el-tabs>
                    </div>

                    <div class="room-chat">
                        <div class="chat-bar" v-if="false">

                            <el-popover
                                v-if="room.isLiving"
                                placement="right"
                                width="180"
                                trigger="hover">
                                <p style="margin-bottom: 5px;">{{$t('live.someFlowers')}}</p>
                                <el-rate
                                    class="live-flower"
                                    v-model="score"
                                    :icon-classes="{2:'inuc-hua1', 4:'inuc-hua2', 5:'inuc-hua3'}"
                                    void-icon-class="inuc-hua2"
                                    :colors="['#99A9BF', '#F7BA2A', '#FF9900']"
                                    @change="scoreChange">
                                </el-rate>
                                <el-badge :is-dot="!score" slot="reference">
                                    <i v-if="!score" class="nucfont inuc-hua0 bar-score" ></i>
                                    <i v-else-if="score<=2" class="nucfont inuc-hua1 bar-score"></i>
                                    <i v-else-if="score<=4" class="nucfont inuc-hua2 bar-score"></i>
                                    <i v-else class="nucfont inuc-hua3 bar-score"></i>
                                </el-badge>
                            </el-popover>

                        </div>
                        <div class="chat-send">
                            <el-input
                                class="comment-textarea"
                                type="textarea"
                                :rows="2"
                                :placeholder="$t('tip.input')"
                                maxlength="200"
                                resize="none"
                                v-model="comment"
                                @keydown.enter.native.prevent="postComment"
                            >
                            </el-input>
                            <el-button @click="postComment" v-if="!limitSecond" class="btn-comment" type="primary" size="mini">
                                {{$t('live.send')}}
                            </el-button>
                            <el-button v-if="limitSecond" class="btn-comment" type="primary" size="mini" :disabled="true">
                                {{limitSecond}} {{$t('count.s')}}
                            </el-button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="close-btn"  @click="$router.back()">
                <span class="close-title">{{$t('c.logOut')}}</span><i class="nucfont inuc-remove-circle close-icon"></i>
            </div>
        </div>

        <live-video-extend
            ref="videoExtend"
            @lineChanged="lineChanged"
            @resetPlayer="resetPlayer"
        ></live-video-extend>

    </div>
</template>

<script>
    import api from '@/api'
    import {Ticket, Storage} from '@/utils'
    import {aesDecrypt} from '@/utils/md5'
    import {TcPlayer} from '@/assets/lib/tcplayer'
    import LiveVideoExtend from "./Components/LiveVideoExtend"
    import dayjs from 'dayjs'

    export default {
        props: ['id', 'password'],
        components: {
            LiveVideoExtend
        },
        data() {
            return {
                room: {},
                status: null,   // 0未开播 1直播中 2已下播 3重连中
                comment: '',
                commentList: [],
                memberList: [],
                limitSecond: 0,
                onlineNum: 0,
                line: 0,     // 线路 0主线 1海外
                activeTab: 'chat',
                score: null
            }
        },

        computed: {
            userInfo() {
                return Ticket.get()
            }
        },

        mounted() {
            if (Storage.get('live_line') !== null) {
                this.line = Storage.get('live_line')
            } else if (navigator.language !== 'zh-CN') {
                this.line = 1
            }

            this.getDetail().then(() => {
                // 进房间时，如果是开播状态，则取历史评论
                if (this.status === 1) {
                    this.getHistoryComment()
                }
            })

            // 初始化评论
            this.getComments()

            // 获取在线人数
            this.getOnlineNum()

            $(window).on('resize', () => {
                //console.log('resize')
                this.resetVideoSize()
            })
        },

        watch: {
            commentList(v) {
                this.toBottom()
            }
        },

        methods: {
            getDetail() {
                let data = {}

                if (this.password && this.password != 0) {
                    data.password = aesDecrypt(this.password, 'live')
                }

                return api.getLiveRoomDetail(this.id, data).then(res => {
                    this.room = res.package
                    this.score = this.room.score

                    this.destroyPlayer()

                    if (this.room.playList) {
                        this.status = 1

                        this.initPlayer()
                    } else {
                        this.status = 0
                    }
                })
            },

            // 获取历史留言
            getHistoryComment() {
                let queryId = this.room.sequence

                this.$api.getLivingCommentStatistic(queryId).then(res => {
                    let data = res.package
                    if (!data.length) return

                    this.commentList = data
                    this.commentList.forEach(item => {
                        item.time = item.createLocalTime && item.createLocalTime.slice(11,16)
                    })
                }).catch(e => {
                    console.log(e)
                })
            },

            freshVideo() {
                this.status = 3
                setTimeout(() => {
                    this.getDetail()
                }, 1500)
            },

            initPlayer() {
                this.status = 1

                let tc = TcPlayer
                let playList = this.room.playList

                let options = {
                    // mp4 :'//1256993030.vod2.myqcloud.com/d520582dvodtransgzp1256993030/7732bd367447398157015849771/v.f40.mp4',
                    // mp4_hd :'//1256993030.vod2.myqcloud.com/d520582dvodtransgzp1256993030/7732bd367447398157015849771/v.f30.mp4',
                    // mp4_sd : '//1256993030.vod2.myqcloud.com/d520582dvodtransgzp1256993030/7732bd367447398157015849771/v.f20.mp4',
                    m3u8: [playList.hls, playList.os_hls][this.line],    // m3u8兼容性好，但是延迟高
                    m3u8_hd: [playList.hls_hd, playList.os_hls_hd][this.line],
                    m3u8_sd: [playList.hls_sd, playList.os_hls_sd][this.line],
                    flv: [playList.flv, playList.os_flv][this.line],     // flv专用于pc端
                    flv_hd: [playList.flv_hd, playList.os_flv_hd][this.line],
                    flv_sd: [playList.flv_sd, playList.os_flv_sd][this.line],
                    rtmp: [playList.rtmp, playList.os_rtmp][this.line],   // flash专用
                    rtmp_hd: [playList.rtmp_hd, playList.os_rtmp_hd][this.line],
                    rtmp_sd: [playList.rtmp_sd, playList.os_rtmp_sd][this.line],
                    flash: true,
                    h5_flv: true,
                    autoplay: true,
                    live: true,
                    wording: {
                        2: this.$t('live.internetError')
                    },
                    listener: (msg) => {
                        //console.log(msg)

                        this.$refs.videoExtend.init(msg)

                        if (msg.type == 'load') {
                            this.player.play()
                        }

                        if (msg.type == 'resize') {
                            console.log('video resize')
                            setTimeout(() => {
                                this.resetVideoSize()
                            }, 0)
                        }

                        if (msg.type == 'ended') {
                            this.destroyPlayer()
                            this.status = 2
                        }
                        if (msg.type == 'error') {
                            if (msg.detail.code === 2) {
                                let data = {}
                                if (this.password && this.password != 0) {
                                    data.password = aesDecrypt(this.password, 'live')
                                }

                                api.getLiveRoomDetail(this.id, data).then(res => {
                                    this.room = res.package

                                    // hls情况下下播
                                    if (!res.package.playList) {
                                        this.status = 2
                                        this.destroyPlayer()

                                        // 网络错误，几s后重试
                                    } else {
                                        return
                                        this.status = 3
                                        this.destroyPlayer()
                                        setTimeout(() => {
                                            this.initPlayer()
                                        }, 3000)
                                    }
                                })
                            }
                        }
                    }
                }

                this.player = new tc('room-video', options)
            },

            lineChanged(i) {
                this.line = i
                Storage.set('live_line', i)
                this.resetPlayer()
            },

            resetPlayer() {
                this.destroyPlayer()
                this.initPlayer()
            },

            destroyPlayer() {
                this.player && this.player.destroy()
                this.player = null
            },

            getComments(timestamp) {
                let param = {}
                if (timestamp) {
                    param.timestamp = timestamp
                }

                api.getLiveComment(this.id, param).then(res => {
                    let data = res.package

                    // 去掉自己的评论
                    data = data.filter(v => v.userId !== this.userInfo.userID)
                    data.forEach(item => {
                        item.time = item.createLocalTime && item.createLocalTime.slice(11,16)
                    })

                    let shownData = [...this.commentList, ...data]

                    // 超过100条后，超过多少，从最开头减掉多少
                    // if (shownData.length > 100) {
                    //     shownData = shownData.slice(shownData.length - 100)
                    // }

                    if (data.length) this.commentList = [...shownData]

                    if (data.length === 20) {
                        this.getComments(res.message)
                    } else {
                        clearTimeout(this.commentTimer)
                        this.commentTimer = setTimeout(() => {
                            this.getComments(res.message)
                        }, 8000)
                    }

                })
            },

            postComment() {
                if (!this.comment.trim() || this.limitSecond) return
                api.postLiveComment(this.id, this.comment).then(res => {
                    // 马上显示自己的评论
                    this.commentList.push({
                        userId: this.userInfo.userID,
                        userName: this.userInfo.userName,
                        content: this.comment,
                        time: dayjs().format('HH:mm')
                    })

                    this.comment = ''

                    // 几秒发言限制
                    this.limitSecond = 5
                    clearInterval(this.limitTimer)
                    this.limitTimer = setInterval(() => {
                        this.limitSecond--
                        if (this.limitSecond === 0) {
                            clearInterval(this.limitTimer)
                        }
                    }, 1000)

                })
            },

            getOnlineNum() {
                let getNum = () => {
                    api.getOnlineNum(this.id).then(res => {
                        let data = res.package
                        this.onlineNum = data.number
                        this.memberList = data.users
                    })
                }

                getNum()

                clearInterval(this.onlineNumTimer)
                this.onlineNumTimer = setInterval(() => {
                    getNum()
                }, 20000)
            },

            scoreChange(v) {
                api.gradeLive(this.id, v)
            },

            resetVideoSize() {
                $('.vcp-player').css({width: '100%', height: '100%'})
                $('.vcp-player video').css({width: '100%', height: '100%'})
            },

            toBottom() {
                let $message = $('.comment-list')
                this.$nextTick(() => {
                    $message.animate({scrollTop: $message[0].scrollHeight}, 300)
                })

                let $fullMessage = $('.full-comment-list')
                if ($fullMessage.length) {
                    $fullMessage.animate({scrollTop: $message[0].scrollHeight}, 300)
                }
            },

        },

        beforeDestroy() {
            this.commentTimer && clearTimeout(this.commentTimer)
            this.limitTimer && clearInterval(this.limitTimer)
            this.onlineNumTimer && clearInterval(this.onlineNumTimer)

            this.destroyPlayer()
        }
    }
</script>

<style scoped lang="scss">
    @import '~@/style/const.scss';

    .m-listRoom {
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        margin-top: 110px;
        padding: 20px 150px;
        min-width: 1090px;
        z-index: 10;
        background-color: #fff;
        @include scrollbar(#999);
        overflow: auto;

        @media screen and (max-width: 1440px) {
            padding: 30px 80px;
        }
    }

    .room-wrap {
        position: relative;
    }

    .room-left {
        margin-right: 350px;
        @media screen and (max-width: 1440px) {
            margin-right: 340px;
        }
    }

    .room-info {
        padding: 10px 20px;
        border: 1px solid #e5e4e4;
        border-radius: 8px 8px 0 0;

        .room-title {
            display: flex;
            justify-content: space-between;
        }

        .title {
            font-size: 18px;
            font-weight: 600;
        }

        .info {
            margin-top: 5px;
            display: flex;
            align-items: baseline;
            .host {
                margin-right: 10px;
            }
            .time {
                margin-right: 10px;
                font-size: 12px;
                color: #999;
            }
        }

        .num {
            flex: 1;
            text-align: right;
            font-size: 12px;
            color: #999;
            .nucfont {
                font-size: 12px;
            }
            span {
                color: #505050;
                font-weight: 600;
                font-size: 13px;
            }
        }
    }

    .room-video-wrap {
        position: relative;
        padding-top: 56.25%;

        .room-video {
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
        }

        .offline, .leave, .loading {
            background-color: #333;
        }

        .fake-screen {
            background-color: #333;
        }

        .inner-box {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);

            .el-icon-refresh {
                display: block;
                margin-top: 10px;
                text-align: center;
                color: #fff;
                font-size: 24px;
                cursor: pointer;
            }
        }

        .note {
            padding: 20px 40px;
            background-color: rgba(56, 59, 74, .8);
            border-radius: 6px;

            p {
                color: #fff;
                letter-spacing: 1px;
            }
        }
    }

    .room-right {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        width: 320px;
        border: 1px solid #e5e4e4;
        border-radius: 4px;
    }

    .room-aside {
        display: flex;
        flex-direction: column;
        height: 100%;

        .room-desc {
            padding: 8px 10px;
            font-size: 12px;
            color: #999;
            border-bottom: 1px solid #e5e4e4;
            max-height: 70px;
            overflow: auto;
            flex-shrink: 0;
        }

        .room-message {
            flex: 1;
            overflow: hidden;
        }

        .room-chat {
            padding: 10px;
            border-top: 1px solid #e5e4e4;

            .chat-send {
                display: flex;
            }

            .comment-textarea /deep/ textarea {
                font-size: 12px;
                border-radius: 4px 0 0 4px;
                border-right: none;
                font-family: "Helvetica Neue", Helvetica, "Microsoft YaHei";
            }

            .btn-comment {
                border-left: none;
                border-radius: 0 4px 4px 0;
            }
        }
    }

    .chat-bar {
        margin-top: -3px;
        padding: 0 0 5px 5px;
        .bar-score {
            font-size: 20px;
            color: #F7BA2A;
            cursor: pointer;
        }
        .inuc-hua1 {
            color: #99A9BF;
        }
        .inuc-hua2 {
            color: #F7BA2A;
        }
        .inuc-hua3 {
            color: #FF9900;
        }
    }


    .comment-list {
        padding: 10px 10px 0 10px;
        background-color: #f8f8f8;
        overflow: auto;
        .comment-item {
            word-break: break-all;
            + .comment-item {
                margin: 6px 0;
            }
        }

        .user, .content {
            font-size: 13px;
        }

        .user {
            color: $color-theme;
            i {
                margin-left: 4px;
                font-style: normal;
                color: #999;
                font-size: 12px;
            }
        }

        .self {
            color: #ff5d23;
        }
    }

    .member-list {
        padding: 10px;
        background-color: #f8f8f8;
        overflow: auto;

        .member-item {
            display: flex;
            align-items: center;
            padding: 0 10px;
            + .member-item {
                margin: 5px 0;
            }
            .el-avatar {
                font-size: 12px;
            }
            .name {
                margin-left: 8px;
            }
        }
    }

    .close-btn{
        position: absolute;
        top: 6px;
        right: -6%;
        display: flex;
        align-items: center;
        background-color: #efefef;
        border-radius: 12px;
        cursor: pointer;
        transition: all .3s;
        .close-title{
            padding: 2px 5px 2px 10px;
            font-size: 13px;
            color: rgb(47,128,171);
        }
        .close-icon{
            border-radius: 15px;
            color: rgb(47,128,171);
            font-size: 18px;
        }
        &:hover{
            transform: translateY(-2px);
            box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
        }
    }

</style>
<style lang="scss">
    @import '../../style/const';

    .m-liveList {
        .vcp-error-tips {
            width: auto;
            height: auto;
            left: 50%;
            transform: translate(-50%, -50%);
            margin: 0;
            padding: 20px 40px;
            background-color: rgba(56, 59, 74, .8);
            border-radius: 6px;
            color: $c-danger;
        }

        .room-message .el-tabs {
            height: 100%;
            .el-tabs__header {
                margin: 0;
            }
            .el-tabs__nav {
                border-top: none;
                border-left: none;
            }
            .el-tabs__item {
                height: 32px;
                line-height: 32px;
                &.is-active {
                    background-color: #f8f8f8;
                }
            }
            .el-tabs__content,  {
                height: calc(100% - 32px);
            }
            .el-tab-pane, .comment-list, .member-list {
                height: 100%;
            }
        }
    }

    .live-flower {
        .el-rate__icon {
            font-family: "nucfont" !important;
            font-size: 16px;
            font-style: normal;
            -webkit-font-smoothing: antialiased;
            -moz-osx-font-smoothing: grayscale;
        }
    }
</style>
